import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import { AdminProtected } from "@/components/Application/AdminProtected";

import PageError from "@/helpers/components/Errors/PageError";

export const CommonRoutes: RouteObject[] = [
	{
		path: "updatedprocedures",
		lazy: async () => {
			const { ShowUpdatedProcedures: ShowUpdatedProcedures } = await import(
				"@/components/Procedures/ShowUpdatedProcedures"
			);
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								componentStack={componentStack}
								reset={resetError}
							/>
						)}
					>
						<ShowUpdatedProcedures />
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
	{
		path: "showdocumentsused/*",
		children: [
			{
				index: true,
				lazy: async () => {
					const { ShowDocumentsUsed } = await import(
						"@/components/Procedures/ShowDocumentsUsed"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<ShowDocumentsUsed />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
			{
				path: ":id",
				lazy: async () => {
					const { ShowDocumentsUsed } = await import(
						"@/components/Procedures/ShowDocumentsUsed"
					);
					return {
						Component: () => (
							<Sentry.ErrorBoundary
								fallback={({ error, componentStack, resetError }) => (
									<PageError
										error={error}
										componentStack={componentStack}
										reset={resetError}
									/>
								)}
							>
								<ShowDocumentsUsed />
							</Sentry.ErrorBoundary>
						),
					};
				},
			},
		],
	},
	{
		path: "updatedprocedures",
		lazy: async () => {
			const { ShowUpdatedProcedures: ShowUpdatedProcedures } = await import(
				"@/components/Procedures/ShowUpdatedProcedures"
			);
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								componentStack={componentStack}
								reset={resetError}
							/>
						)}
					>
						<ShowUpdatedProcedures />
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
	{
		path: "admin/dashboard",
		lazy: async () => {
			const { AdminDashboard } = await import(
				"@/components/Admin/AdminDashboard/components/AdminDashboard"
			);
			return {
				Component: () => (
					<Sentry.ErrorBoundary
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								componentStack={componentStack}
								reset={resetError}
							/>
						)}
					>
						<AdminProtected>
							<AdminDashboard />
						</AdminProtected>
					</Sentry.ErrorBoundary>
				),
			};
		},
	},
];
